import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=6e3ed006&scoped=true&"
import script from "./Chatroom.vue?vue&type=script&lang=js&"
export * from "./Chatroom.vue?vue&type=script&lang=js&"
import style0 from "./Chatroom.vue?vue&type=style&index=0&id=6e3ed006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ed006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e3ed006')) {
      api.createRecord('6e3ed006', component.options)
    } else {
      api.reload('6e3ed006', component.options)
    }
    module.hot.accept("./Chatroom.vue?vue&type=template&id=6e3ed006&scoped=true&", function () {
      api.rerender('6e3ed006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/chatroom/Chatroom.vue"
export default component.exports